/**
 * Loan Setup Enums
 */

export enum PropertyAvailable {
  SELECTED = 'yes',
  LOOKING = 'no',
}

export enum CoBorrowerType {
  INDIVIDUAL = 'individual',
  JOINT = 'joint',
}
